import React, { useState } from 'react';
import translations from './assets/locale/messages_en.json';
import * as enLocaleData from '@wix/locale-dataset-data/resources/translations/messages_en.json';
import { I18nextProvider, initI18nBase } from '@wix/fe-essentials/i18n';
const defaultNS = 'invoice-view';
export async function i18nLocal({ locale }) {
    const instance = initI18nBase({ locale, disableAutoInit: true });
    const bundles = locale === 'en'
        ? Promise.resolve([translations, enLocaleData])
        : Promise.all([
            import(`./assets/locale/messages_${locale}.json`)
                .then((r) => r.default)
                .catch((error) => {
                console.error('failed to load resources', error);
                return translations;
            }),
            import(`@wix/locale-dataset-data/resources/translations/messages_${locale}.json`)
                .then((r) => r.default)
                .catch((error) => {
                console.error('failed to load language data', error);
                return enLocaleData;
            }),
        ]).catch((error) => {
            console.error('unexpected translation load failure', error);
            return [translations, enLocaleData];
        });
    const [translationBundle, localeData] = await bundles;
    instance.init({
        ns: [defaultNS, 'locale-data'],
        defaultNS,
        lng: locale,
        fallbackLng: 'en',
        keySeparator: '$',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
        resources: {
            en: {
                [defaultNS]: translationBundle,
                'locale-data': localeData,
            },
        },
    });
    return instance;
}
export const withProvider = (TranslatedComponent) => (props) => {
    const [i18nInstance, setInstance] = useState();
    React.useEffect(() => {
        i18nLocal({ locale: props.locale }).then((instance) => {
            setInstance(instance);
        });
    }, [props.locale]);
    if (!i18nInstance) {
        return null;
    }
    return (React.createElement(I18nextProvider, { i18n: i18nInstance },
        React.createElement(TranslatedComponent, { ...props })));
};
//# sourceMappingURL=i18n.js.map